import { RuntimeEnvironment } from '@lx/shared/types';
import { loadPaymentGatewayVariables } from '@lx/shared/payment';

export function getBaseHrefFactory() {
  // Read from window variable first, then fall back to base tag href
  if (window['APP_BASE_HREF']) {
    return window['APP_BASE_HREF'];
  }
  // Get the base href from the <base> tag in the document
  const baseTag = document.querySelector('base');
  return baseTag?.getAttribute('href') ?? '/';
}

export function setBaseHrefFactory(base_href: string) {
  return base_href;
}

export function getPaymentsGatewayVariables(env: RuntimeEnvironment) {
  return loadPaymentGatewayVariables(env);
}
